var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFillPointNone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 94,
  height: 94,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#fill-point-none_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#fill-point-none_svg__b)",
  fillOpacity: 0.8,
  fillRule: "evenodd",
  d: "M85 47a38 38 0 1 1-76 0 38 38 0 0 1 76 0",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36 68.071V32h13.015q4 0 6.71 1.55 2.73 1.55 4.118 4.262 1.407 2.695 1.407 6.13 0 3.47-1.407 6.164-1.406 2.696-4.151 4.245-2.745 1.532-6.762 1.532h-8.626v-5.372h7.779q2.338 0 3.83-.845 1.49-.846 2.203-2.325.728-1.48.728-3.4t-.728-3.381q-.713-1.462-2.22-2.272-1.492-.828-3.847-.828h-5.762v30.611z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fill-point-none_svg__b",
  x1: 76.359,
  x2: 19.801,
  y1: 20.587,
  y2: 77.145,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9E9E9E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.201,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.517,
  stopColor: "#9E9E9E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "fill-point-none_svg__a",
  width: 92,
  height: 92,
  x: 1,
  y: 1,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1877_3914"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1877_3914",
  result: "shape"
})))));
export default SvgFillPointNone;